import React from 'react';
import TableColumnTitle from '../../../../../components/_table/TableColumnTitle';
import { POINT_LOG_TYPE_TEXT } from '../../../../../constants/service/app/pointConstants';

/**
 *  포인트 사유 리스트 컬럼
 */
export const columns = () => {
  return [
    {
      title: <TableColumnTitle title={'순번'} />,
      dataIndex: 'id',
    },
    {
      title: <TableColumnTitle title={'내역 종류'} />,
      dataIndex: 'type',
      render: (value) => POINT_LOG_TYPE_TEXT[value],
    },
    {
      title: <TableColumnTitle title={'적립/사용처'} />,
      dataIndex: 'name',
    },
  ];
};
